<template>
  <section v-if="landing" class="landing-section">
    <div class="landing-hero">
      <div class="landing-copy">
        <div class="landing-tag">ПОСАДОЧНА СТОРІНКА</div>
        <h1>{{ landing.h1 }}</h1>
        <p>{{ landing.intro }}</p>
        <div class="landing-benefits">
          <div v-for="benefit in landing.benefits" :key="benefit" class="landing-benefit">{{ benefit }}</div>
        </div>
      </div>

      <div class="landing-cta">
        <a href="tel:+380682772822" class="landing-btn landing-btn-phone">Подзвонити</a>
        <a href="https://t.me/MobiFIXPRO_bot" target="_blank" rel="noopener" class="landing-btn landing-btn-telegram">Написати в Telegram</a>
        <router-link to="/orders/create" class="landing-btn landing-btn-order">Залишити заявку</router-link>
      </div>
    </div>

    <div class="landing-faq">
      <article v-for="item in landing.faq" :key="item.q" class="landing-faq-card">
        <h3>{{ item.q }}</h3>
        <p>{{ item.a }}</p>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiceLandingSection',
  props: {
    landing: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped>
.landing-section {
  margin-bottom: 24px;
}

.landing-hero {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 18px;
  margin-bottom: 18px;
}

.landing-copy,
.landing-cta,
.landing-faq-card {
  background: #fff;
  border: 1px solid #dde4ff;
  border-radius: 22px;
  box-shadow: 0 10px 28px rgba(46, 44, 97, 0.06);
}

.landing-copy {
  padding: 28px;
}

.landing-tag {
  display: inline-block;
  margin-bottom: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #ebf4ff;
  color: #245bca;
  font-size: 12px;
  font-weight: 800;
}

.landing-copy h1 {
  margin: 0 0 12px;
  font-size: 36px;
  line-height: 1.1;
  color: #1f2357;
}

.landing-copy p {
  margin: 0 0 16px;
  color: #4d5671;
  line-height: 1.75;
  font-size: 16px;
}

.landing-benefits {
  display: grid;
  gap: 10px;
}

.landing-benefit {
  padding: 12px 14px;
  border-radius: 14px;
  background: #f4f7ff;
  color: #33405f;
  font-size: 14px;
  font-weight: 700;
}

.landing-cta {
  padding: 22px;
  display: grid;
  gap: 12px;
  align-content: start;
}

.landing-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 52px;
  border-radius: 14px;
  text-decoration: none;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
}

.landing-btn-phone { background: linear-gradient(135deg, #1d9e75, #2cc48b); }
.landing-btn-telegram { background: linear-gradient(135deg, #1694f3, #2bc1ff); }
.landing-btn-order { background: linear-gradient(135deg, #534ab7, #7f77dd); }

.landing-faq {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.landing-faq-card {
  padding: 20px;
}

.landing-faq-card h3 {
  margin: 0 0 10px;
  font-size: 18px;
  color: #1f2357;
}

.landing-faq-card p {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #5b6480;
}

@media (max-width: 900px) {
  .landing-hero,
  .landing-faq {
    grid-template-columns: 1fr;
  }

  .landing-copy h1 {
    font-size: 30px;
  }
}
</style>
